import { EZoneCategory, getDate, request } from '@watcherr/resources';
import { addHours, subHours } from 'date-fns';
import { clamp } from 'lodash';

export type LocationStatsAggregate = {
  category: EZoneCategory | null;
  seconds: number;
};

export type LocationStatsSession = {
  category: EZoneCategory | null;
  timestamp: number;
  seconds: number;
  zoneId?: string;
  zoneName?: string;
  planeId?: number;
  planeName?: string;
};

const getEndTimestamp = (session: LocationStatsSession) => session.timestamp + session.seconds * 1000;
const msToSec = (ms: number) => Math.round(ms / 1000);

export async function fetchLocationStatSessions(
  profileId: number,
  startDate: Date,
  endDate: Date
): Promise<LocationStatsSession[]> {
  // Add extra data at start and end of date, then clamp this
  const data = await request.get({
    path: `/profiles/${profileId}/stats/location?start_date=${subHours(startDate, 1).toISOString()}&end_date=${addHours(endDate, 1).toISOString()}&view=sessions`,
  });
  if (!data.length) return [];
  // // Clamp the splits
  let result: LocationStatsSession[] = data.map((x) => {
    const timestamp = getDate(x.timestamp).getTime();
    const start = clamp(timestamp, startDate.getTime(), endDate.getTime());
    const end = clamp(timestamp + x.seconds * 1000, startDate.getTime(), endDate.getTime());
    return {
      category: x.category,
      timestamp: start,
      seconds: msToSec(Math.max(end - start, 0)),
      zoneId: x.zone_id,
      zoneName: x.zone_name,
      planeId: x.plane_id,
      planeName: x.plane_name,
    };
  });

  // Add missing start & end point
  if (!result.some((x) => x.timestamp === startDate.getTime())) {
    const first = result[0];
    result = [
      { category: null, seconds: msToSec(first.timestamp - startDate.getTime()), timestamp: startDate.getTime() },
      ...result,
    ];
  }
  if (!result.some((x) => getEndTimestamp(x) === endDate.getTime())) {
    const last = result[result.length - 1];
    const timestamp = last.timestamp + last.seconds * 1000;
    result = [...result, { category: null, seconds: msToSec(endDate.getTime() - timestamp), timestamp }];
  }
  result = result.filter((x) => x.seconds > 0);

  console.log(
    'TOTAL',
    result.reduce((acc, val) => acc + val.seconds, 0)
  );
  console.log('START', result[0].timestamp, startDate.getTime());
  console.log('END', getEndTimestamp(result[result.length - 1]), endDate.getTime());
  console.log(result);

  return result;
}

export function fetchLocationStatAggregates(
  profileId: number,
  startDate: Date,
  endDate: Date
): Promise<LocationStatsAggregate[]> {
  return request.get({
    path: `/profiles/${profileId}/stats/location?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}&view=aggregate`,
  });
}
